import request from '../request'


export function postLogin(data) {
    return request({
        url: `/user/password/check`,
        method: 'post',
        data
    })
}